import NationalNav from "@/components/national/NationalNav";
import NationalHero from "@/components/national/NationalHero";
import CitiesSection from "@/components/national/CitiesSection";
import Positioning from "@/components/national/Positioning";
import Audience from "@/components/national/Audience";
import Gallery2026 from "@/components/national/Gallery2026";
import Topics from "@/components/national/Topics";
import VarnaFunnel from "@/components/national/VarnaFunnel";
import Organizer from "@/components/national/Organizer";
import PartnerWall from "@/components/national/PartnerWall";
import InterestSection from "@/components/national/InterestSection";
import FinalCTA from "@/components/national/FinalCTA";
import NationalFooter from "@/components/national/NationalFooter";

export default function NationalHome() {
  return (
    <main data-testid="national-home" className="relative bg-[#0B1F3D]">
      <NationalNav />
      <NationalHero />
      <CitiesSection />
      <Positioning />
      <Audience />
      <Gallery2026 />
      <Topics />
      <VarnaFunnel />
      <Organizer />
      <PartnerWall />
      <InterestSection />
      <FinalCTA />
      <NationalFooter />
    </main>
  );
}
